import React, { useEffect, useState } from "react";
import { Spin, Empty, Pagination, message } from "antd";
import moment from "moment";
import { platformApi } from "../../../../api";
import { useBranch } from "../../../../ContextAPI/branch";
import "../index.less";

const BookingHistoryTable = () => {
  const { selectBranch } = useBranch();
  const [history, setHistory] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [loading, setLoading] = useState(false);

  const fetchHistory = async (page = 1, size = 10) => {
    try {
      if (!selectBranch || selectBranch.length === 0) return;
      setLoading(true);

      const branch = selectBranch.map((b) => b.id);
      const res = await platformApi.post(`/api/booking/history`, {
        branch,
        page,
        size,
      });

      const { data, pagination: pageInfo } = res.data;
      setHistory(data || []);
      setPagination({
        current: pageInfo?.page || page,
        pageSize: pageInfo?.size || size,
        total: pageInfo?.total || 0,
      });
    } catch (err) {
      console.error(err);
      message.error("Failed to fetch booking history");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory(1, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectBranch]);

  const formatStatus = (status) => {
    if (!status) return "-";
    const s = status.toUpperCase();
    if (s === "PENDING") return "Unauthorize";
    if (s === "ACCEPTED") return "Authorize";
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };

  const handlePageChange = (page, pageSize) => {
    fetchHistory(page, pageSize || pagination.pageSize);
  };

  const getFields = (record, index) => [
    {
      key: "index",
      label: "S.No",
      value:
        (pagination.current - 1) * pagination.pageSize + (index + 1),
    },
    {
      key: "bookingId",
      label: "Booking ID",
      value: record?.booking?.bookingId || "-",
    },
    {
      key: "customer",
      label: "Customer",
      value: record?.booking?.customer?.name || "-",
    },
    {
      key: "module",
      label: "Action",
      value: record?.module || "-",
    },
    {
      key: "fromStatus",
      label: "From Status",
      value: formatStatus(record?.fromStatus),
    },
    {
      key: "toStatus",
      label: "To Status",
      value: formatStatus(record?.toStatus),
    },
    {
      key: "changedBy",
      label: "Changed By",
      value: record?.changedBy?.profile?.employeeName || "-",
    },
    {
      key: "createdAt",
      label: "Date",
      value: record?.createdAt
        ? moment(new Date(record.createdAt)).format("DD/MM/YYYY HH:mm")
        : "-",
    },
  ];

  return (
    <div className="register-history-list register-record-list">
      <Spin spinning={loading}>
        {!history || history.length === 0 ? (
          <Empty description="No history" style={{ margin: "40px 0" }} />
        ) : (
          <div className="register-record-cards">
            {history.map((record, index) => (
              <div
                key={record.id}
                className={`register-record-card register-history-card${
                  index % 2 === 1 ? " register-record-card--alt" : ""
                }`}
              >
                <div className="register-record-card__body">
                  {getFields(record, index).map((field) => (
                    <div
                      key={field.key}
                      className={`register-record-card__field register-record-card__field--${field.key}`}
                    >
                      <span className="register-record-card__label">
                        {field.label}
                      </span>
                      <div className="register-record-card__value">
                        {field.value}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </Spin>

      {pagination.total > 0 && (
        <div className="register-record-pagination">
          <Pagination
            current={pagination.current}
            pageSize={pagination.pageSize}
            total={pagination.total}
            onChange={handlePageChange}
            showSizeChanger={false}
          />
        </div>
      )}
    </div>
  );
};

export default BookingHistoryTable;
